import './src/main.css'
import BorderBox1 from './src/main.vue'

export default function (Vue) {
  Vue.component(BorderBox1.name, BorderBox1)
}



// WEBPACK FOOTER //
// ./~/@jiaminghi/data-view/lib/components/borderBox1/index.js